import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-multiple-row',
  templateUrl: './add-multiple-row.component.html',
  styleUrls: ['./add-multiple-row.component.css']
})
export class AddMultipleRowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
